export const LogoDesign = ()=>{
    return <svg width="361" height="307" viewBox="0 0 361 307" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.2">
    <path opacity="0.3" d="M131.408 285.164H322.21V358.823H-22.7011L265.599 0H361L131.408 285.164Z" fill="white"/>
    <path d="M70.5915 73.6587H-120.211V0H224.701L-63.5989 358.823H-159L70.5915 73.6587Z" fill="white"/>
    <g opacity="0.2">
    <g opacity="0.2">
    <mask id="mask0_3860_34597"  maskUnits="userSpaceOnUse" x="-121" y="-1" width="248" height="76">
    <g opacity="0.2">
    <g opacity="0.2">
    <path opacity="0.2" d="M126.206 -0.00012207H-120.159V74.1848H126.206V-0.00012207Z" fill="url(#paint0_linear_3860_34597)"/>
    </g>
    </g>
    </mask>
    <g mask="url(#mask0_3860_34597)">
    <path opacity="0.2" d="M126.193 -0.000244141H-120.172V74.1846H126.193V-0.000244141Z" fill="url(#paint1_linear_3860_34597)"/>
    </g>
    </g>
    </g>
    </g>
    <defs>
    <linearGradient id="paint0_linear_3860_34597" x1="126.776" y1="36.6047" x2="-119.53" y2="36.6047" gradientUnits="userSpaceOnUse">
    <stop stopColor="white"/>
    <stop offset="1"/>
    </linearGradient>
    <linearGradient id="paint1_linear_3860_34597" x1="126.764" y1="36.6046" x2="-119.543" y2="36.6046" gradientUnits="userSpaceOnUse">
    <stop stopColor="#231F20"/>
    <stop offset="1" stopColor="white"/>
    </linearGradient>
    </defs>
    </svg>
    
    
}